e.M.loop = {
	api : config.api + 'my_classes',

	init : function(){
		$( '.restore-class' ).click( this._restore_class );
	},

	_restore_class : function(){
		var el = $( this );
		var $data = {
			method : 'restore_class_from_archive',
			post_id : el.data( 'post_id' )
		};

		$.post( e.M.loop.api, $data , function( response ){} );


		el.parents( '.class' ).remove();
		var messages = new e.Messages();
		messages.display_message( 'class_restored' );

	}

};